/* eslint-disable camelcase */
export const toastOptions = {
  // Define default options
  success: {
    className: 'toast-success',
    style: {
      background: '#02CD9A',
      color: '#fff',
      padding: '16px',
      fontWeight: '500',
      fontSize: '14px',
      boxShadow:
        'rgb(45 80 230 / 40%) 0px 4px 24px, rgb(0 0 0 / 12%) 0px 4px 24px',
    },
    iconTheme: {
      primary: 'white',
      secondary: '#02CD9A',
    },
  },
  error: {
    className: 'toast-error',
    style: {
      background: '#d95762',
      color: '#fff',
      padding: '16px',
      fontSize: '14px',
      fontWeight: '500',
      boxShadow:
        'rgb(233 30 99 / 50%) 0px 4px 24px, rgb(0 0 0 / 12%) 0px 4px 24px',
      width: '700px!important',
    },
    iconTheme: {
      primary: 'white',
      secondary: '#d95762',
    },
  },
}

export const contractColors = {
  CDI: '#108ee9',
  CDD: '#00bcd4',
  STAGE: '#ff5722',
  ALTERNANCE: '#673ab7c7',
  INTERIM: '#87d068',
  default: 'blue',
}

export const contractTypes = (t) => [
  { value: 'CDI', label: t('campaign:offer.type.cdi') },
  { value: 'CDD', label: t('campaign:offer.type.cdd') },
  { value: 'internship', label: t('campaign:offer.type.internship') },
  { value: 'Interim', label: t('campaign:offer.type.interim') },
  { value: 'trainingCourse', label: t('campaign:offer.type.trainingCourse') },
]

export const schoolLevelsI18 = (t) => ({
  2: t('common:bac2'),
  3: t('common:bac3'),
  4: t('common:bac4'),
  5: t('common:bac5'),
  above: t('common:bacAbove'),
})

export const remote = (target, t) => {
  switch (target) {
    case 'FULL':
      return t('campaign:offer.remoteWorking.full')
    case 'PARTIAL':
      return t('campaign:offer.remoteWorking.partial')
    case 'PUNCTUAL':
      return t('campaign:offer.remoteWorking.punctual')
    case 'UNAUTHORIZED':
      return t('campaign:offer.remoteWorking.unauthorized')
    default:
      return 'Not specified'
  }
}

export const remoteOptions = (t) => [
  { value: 'FULL', label: t('campaign:offer.remoteWorking.full') },
  { value: 'PARTIAL', label: t('campaign:offer.remoteWorking.partial') },
  { value: 'PUNCTUAL', label: t('campaign:offer.remoteWorking.punctual') },
  {
    value: 'UNAUTHORIZED',
    label: t('campaign:offer.remoteWorking.unauthorized'),
  },
]

export const experienceOptions = (t) => ({
  junior: t('common:exp.junior'),
  intermediate: t('common:exp.intermediate'),
  senior: t('common:exp.senior'),
  expert: t('common:exp.expert'),
  moreThanTen: t('common:exp.moreThanTen'),
})

export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const capitalizeAllWords = (s) => {
  if (typeof s !== 'string') return ''
  return s
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ')
}

export function getRandNumber(limit) {
  return Math.floor(Math.random() * limit + 1)
}

function importAll(r) {
  return r.keys().map(r)
}

export const images = importAll(
  require.context('../assets/images/', false, /\.(png|jpe?g|svg)$/),
)

/**
 * Takes an id of width minimum length 6 and returns a number from the byte array
 * @param {string} element
 * @returns number
 */
export const makeUniqueNumber = (element) => {
  if (typeof element !== 'string' || element.length < 5) {
    return getRandNumber(10)
  }

  return [...Buffer.from(element.slice(5))].reduce((acc, el) => acc + el)
}

/**
 *
 * Take object from react autocomplete api and format new object
 * @param {string} address_components
 * @param {array} formatted_address
 * @returns number
 */
export const formatLocation = ({ address_components, formatted_address }) => {
  const location = {
    formattedAddress: formatted_address,
    city: null,
    state: null,
    country: null,
  }
  if (address_components?.length) {
    // eslint-disable-next-line array-callback-return
    address_components.map((address) => {
      if (address.types.includes('locality')) {
        location.city = address.long_name
      }
      if (address.types.includes('administrative_area_level_1')) {
        location.state = address.long_name
      }
      if (address.types.includes('country')) {
        location.country = address.long_name
      }
    })
    return location
  }
}

/**
 *
 */
export const isEmptyObject = (obj) => {
  if (obj === undefined || obj === null) return true

  return Object.keys(obj).length === 0
}

/**
 *
 */
export const calculateAverage = (array) => {
  let total = 0
  let count = 0

  array.forEach((item) => {
    total += item
    count += 1
  })
  return total / count
}

export const checkNumber = (myString) => /\d/.test(myString)
export const checkUppercase = (myString) => /[A-Z]/.test(myString)
export const checkLowercase = (myString) => /[a-z]/.test(myString)
export const checkSpecial = (myString) => {
  const specials = /[!@#$%^&*(),.?":{}|<>]/
  return specials.test(myString)
}
